module.exports = __webpack_public_path__ + "img/ui_base_link_transcript.4f9b6703.png";